(function () {
  if (window.__ssCartDrawer) return;
  window.__ssCartDrawer = true;

  const RECO_SECTION = 'ss-cart-recommendations';
  const isFr = () => String((window.SS && SS.locale) || document.documentElement.lang || 'fr').toLowerCase().startsWith('fr');

  /* N'écrit que si le texte change : le tiroir est surveillé par un
     MutationObserver, une écriture identique relancerait la boucle. */
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  /* --- Devise ---
     SS.formatMoney s'appuie sur le format de la boutique (euros). Quand le
     client paie dans une autre devise (USD, GBP, CHF…), on formate avec Intl
     dans la devise du panier, sinon on afficherait un montant en dollars avec
     le symbole €. */
  function moneyInfo() {
    const el = document.querySelector('[data-ss-cd-money]');
    const active = (el && el.dataset.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    const shop = (el && el.dataset.shopCurrency) || active;
    const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return { active, shop, rate, foreign: Boolean(active && shop && active !== shop) };
  }

  function fmt(cents) {
    const m = moneyInfo();
    if (!m.foreign) return SS.formatMoney(cents);
    try {
      const lang = document.documentElement.lang || (isFr() ? 'fr' : 'en');
      return new Intl.NumberFormat(lang, { style: 'currency', currency: m.active }).format(cents / 100);
    } catch (e) {
      return SS.formatMoney(cents);
    }
  }

  /* Seuil en euros (centimes) -> devise du panier (centimes) */
  function convert(eurCents) {
    const m = moneyInfo();
    return m.foreign ? Math.round(eurCents * m.rate) : eurCents;
  }

  /* --- Recommandations --- */
  async function loadReco(root) {
    const productId = root.dataset.productId;
    if (!productId) return;

    /* Horizon re-rend le tiroir à chaque retrait d'article (morph) : le
       conteneur peut être conservé avec son marqueur « chargé » alors que
       son rail a été vidé. On ne saute donc le chargement que si le rail
       contient bien des cartes pour ce même produit. */
    const currentRail = root.querySelector('[data-ss-cd-reco-rail]');
    if (root.dataset.loaded === productId && currentRail && currentRail.children.length) {
      root.hidden = false;
      return;
    }
    if (root.dataset.loaded === productId + ':empty') return;
    if (root.dataset.loading === productId) return;
    root.dataset.loading = productId;
    root.hidden = true;

    const params = new URLSearchParams({
      section_id: RECO_SECTION,
      product_id: productId,
      limit: root.dataset.limit || '6',
      intent: root.dataset.intent || 'related'
    });

    try {
      let base = (window.SS && SS.routes && SS.routes.root) || '/';
      if (!base.endsWith('/')) base += '/';
      const res = await fetch(`${base}recommendations/products?${params}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const rail = doc.querySelector('[data-ss-cd-reco-rail]');
      const target = root.querySelector('[data-ss-cd-reco-rail]');

      if (!rail || !rail.children.length || !target) {
        root.dataset.loaded = productId + ':empty';
        return;
      }

      /* SS 30/09 — chargement immédiat des images : sur Safari iOS, une image
         « lazy » placée dans un rail à défilement horizontal, à l'intérieur
         d'un tiroir qui s'ouvre, peut ne jamais se charger (cadre vide). */
      rail.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));

      target.innerHTML = rail.innerHTML;
      root.dataset.loaded = productId;
      root.hidden = false;

      window.ssScanAnimations?.(target);
    } catch (err) {
      console.error('SS — recommandations panier :', err);
    } finally {
      delete root.dataset.loading;
    }
  }

  /* --- Barre de livraison offerte ---
     Le seuil dépend du pays (calculé en Liquid, en euros). Si le panier
     est dans une autre devise, on le convertit ici au taux Shopify. */
  function updateFreeShipping(total) {
    document.querySelectorAll('[data-ss-cd-freeship]').forEach((el) => {
      let threshold = parseInt(el.dataset.threshold, 10);
      if (!threshold || threshold <= 0) {
        const eur = parseInt(el.dataset.thresholdEur, 10);
        if (!eur || eur <= 0) return;
        threshold = convert(eur);
      }

      const cartTotal = typeof total === 'number' ? total : parseInt(el.dataset.total, 10) || 0;
      const reached = cartTotal >= threshold;
      const percent = Math.min(100, Math.round((cartTotal / threshold) * 100));

      const fill = el.querySelector('[data-ss-cd-freeship-fill]');
      if (fill) fill.style.width = `${percent}%`;

      const track = el.querySelector('[data-ss-cd-freeship-track]');
      if (track) track.setAttribute('aria-valuenow', percent);

      const text = el.querySelector('[data-ss-cd-freeship-text]');
      setText(text, reached
        ? el.dataset.textReached || ''
        : (el.dataset.textPending || '').replace('{amount}', fmt(threshold - cartTotal)));

      el.classList.toggle('is-reached', reached);
      if (track) track.setAttribute('aria-label', text ? text.textContent : '');
    });

    /* Montant du seuil dans l'argument « Livraison offerte dès … » */
    document.querySelectorAll('[data-ss-fs-amount]').forEach((el) => {
      if (el.textContent.trim()) return;
      const eur = parseInt(el.dataset.eur, 10);
      if (eur > 0) setText(el, fmt(convert(eur)));
    });
  }

  /* --- Total dans le bouton de commande ---
     15/10 : le libellé était lu dans SS_CONFIG.strings.checkout, qui n'existe
     pas (il est dans SS_CONFIG.checkout) : le bouton restait « Passer
     commande » même en anglais. */
  function updateCheckout(total) {
    const cfg = window.SS_CONFIG || {};
    const base = cfg.checkout || (cfg.strings && cfg.strings.checkout) || (isFr() ? 'Passer commande' : 'Check out');
    document.querySelectorAll('.cart-drawer__summary .cart__checkout-button .button-text')
      .forEach((el) => setText(el, total ? `${base} — ${total}` : base));
  }

  /* --- Passe complète sur le tiroir --- */
  function refresh(cart) {
    document.querySelectorAll('[data-ss-cd-reco]').forEach(loadReco);

    if (cart) {
      updateCheckout(fmt(cart.total_price));
      updateFreeShipping(cart.total_price);

      const fr = isFr();
      document.querySelectorAll('[data-ss-cd-count]').forEach((el) => {
        const plural = cart.item_count > 1;
        const label = fr ? (plural ? 'articles' : 'article') : (plural ? 'items' : 'item');
        setText(el, `${cart.item_count} ${label}`);
      });
    } else {
      const el = document.querySelector('.cart-drawer__summary [data-cart-subtotal]');
      updateCheckout(el?.textContent.trim());
      updateFreeShipping();
    }
  }

  document.addEventListener('ss:cart:update', (e) => refresh(e.detail?.cart));

  /* Le morph d'Horizon recrée le DOM : on repasse après chaque mutation */
  const observer = new MutationObserver(SS.debounce(() => refresh(), 120));

  /* SS 30/09 — ouverture du panier après un ajout.
     Horizon n'ouvre le tiroir que si <cart-drawer-component> porte l'attribut
     « auto-open » (réglage « Ouvrir automatiquement le panier », décoché ici) :
     après un ajout, rien ne s'affichait, sur mobile comme sur ordinateur. */
  function enableAutoOpen() {
    document.querySelectorAll('cart-drawer-component').forEach((el) => {
      if (!el.hasAttribute('auto-open')) el.setAttribute('auto-open', '');
    });
  }

  function watch() {
    enableAutoOpen();
    const inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;
    observer.observe(inner, { childList: true, subtree: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  document.addEventListener('shopify:section:load', watch);
})();
